import { v4 as uuid } from 'uuid';

import { ContactAdjusterInternalEmail } from '../types/type';

export async function emailAdjuster(
  urlKey: string,
  sessionId: string,
  custKey: string,
  model: ContactAdjusterInternalEmail
) {
  try {
    const postBody = {
      messageBccList: [],
      messageCcList: [],
      messageComments: [],
      messageContent: makeEmailBody(model),
      messageContentType: 'text/html',
      messageFrom: {
        address: 'contact_adjuster@amfam.com',
        name: 'Contact Adjuster',
      },
      messageHeaders: [],
      messageKeywords: [],
      messageReplyToList: [],
      messageSubject: `${model.claimNumber}: American Family Insurance Claim Communication`,
      messageToList: [{ address: model.adjusterEmail, name: model.adjusterName }],
    };

    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}emails`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(postBody),
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      return responseData;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

function makeEmailBody(postBody: ContactAdjusterInternalEmail) {
  let content = `Dear ${postBody.adjusterName},<br><br>`;
  content += `The customer below has submitted a question/comment about his/her claim(s).<br><br>`;
  content += `Please contact the customer within two business days to discuss their request.<br><br>`;
  content += `Thank you`;
  content += `<br><br><hr/><br><br>Request Change<br>`;
  content += `The following is the message from the customer about his/her claim(s).<br><br>`;
  content += `<table><tr><td>Last Name</td><td>${postBody.lastName}</td></tr>`;
  content += `<tr><td>First Name</td><td>${postBody.firstName}</td></tr>`;
  content += `<tr><td>Email</td><td>${postBody.email}</td></tr>`;
  content += `<tr><td>Phone</td><td>${postBody.phone}</td></tr>`;
  content += `<tr><td>Comments</td><td>${postBody.comment}</td></tr>`;
  content += `</table>`;
  content += `<br><br><hr/>`;

  return content;
}
